module.exports = __webpack_public_path__ + "img/circular-dot.224d8a44.svg";